module.exports = __webpack_public_path__ + "static/media/bg-login-skyEX.f150aa4a.jpg";